import React from "react";
import "./Popup1.css";
function Popup1({ Open, onClose , Content , height}) {
  if (!Open) return null; // If Open is false, don't render the popup

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div className={`popup-content`} style={{height}} onClick={(e) => e.stopPropagation()}>
        <div className="popup-content-layer">
            {Content}
        </div>
      </div>
    </div>
  );
}

export default Popup1;
